module.exports = __webpack_public_path__ + "img/buduo.13865ff0.png";